import { asNumber, asRecord, asString } from "@/data/mapper/common/mapper-utils";
import { TreatmentPatientInfoEntity } from "@/domain/entity/treatment/treatment-list-entity";

export class TreatmentPatientInfoMapper {
  static toEntity(dto: unknown): TreatmentPatientInfoEntity {
    const map = asRecord(dto);
    return {
      name: nullableString(map.name ?? map.fullName ?? map.patientName),
      phone: nullableString(map.phone ?? map.patientPhone),
      email: nullableString(map.email ?? map.patientEmail),
      birthDate: nullableString(map.birthDate ?? map.birthday ?? map.patientBirthday),
      age: map.age == null ? null : asNumber(map.age),
      gender: nullableString(map.gender ?? map.patientGender),
      memo: nullableString(map.memo ?? map.patientMemo),
    };
  }
}

function nullableString(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  if (typeof value === "object") return null;
  return asString(value);
}
